import { render, staticRenderFns } from "./InquiryFormInstructions.vue?vue&type=template&id=dc5d5616&scoped=true"
import script from "./InquiryFormInstructions.vue?vue&type=script&lang=js"
export * from "./InquiryFormInstructions.vue?vue&type=script&lang=js"
import style0 from "./InquiryFormInstructions.vue?vue&type=style&index=0&id=dc5d5616&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc5d5616",
  null
  
)

export default component.exports